import { loginConstants } from '../_constants/login.constants';
// let user = localStorage.getItem('firstName')
const initialState =  {};
 function authentication(state = initialState, action) {
  switch (action.type) {
    // case loginConstants.LOGIN_REQUEST:
    //   return {
    //     loggingIn: true,
    //     user: action.user
    //   };
    case loginConstants.LOGIN_SUCCESS:
      console.log("data",action.data)
      return {
        loggedIn: true,
        
        user: action.data,
        hasOpen: false 
      };
    case loginConstants.LOGIN_FAILURE:
      return {
        hasOpen: true 
      };
  
    default:
      return state
  }
}

export default authentication;